/**
 * « Ordonnancier » (/ordonnancier, /ordonnancier/:id) — screen CONFIG (cross-module X XWP-55; CP §15.13,
 * §15.14, §15.21-9; XMD-CP-11). Platform-governed UI values only: the business vocabulary and bounds
 * (attachment kinds, accepted types, caps, dispensation bounds, sort whitelist, statuses) are the shared
 * twin `@pharmakon/shared/constants/ordonnancier.js`, pinned to the server CONFIG by
 * `apps/server/src/__tests__/ordonnancier.parity.test.js` — never retyped here (PK-BUG-15); « Jours
 * restants » is computed by the server with `@pharmakon/shared/traitement` (XD-272) and never here.
 */
import {
  CHAMPS_DISPENSATION_CORRIGEABLES,
  EXTENSIONS_PIECE_ORDONNANCIER,
  LIBELLES_CHAMPS_DISPENSATION,
  MIMES_PIECE_ORDONNANCIER,
  ORDONNANCIER_DISPENSATION_BORNES,
  PIECES_ORDONNANCIER_BORNES,
  STATUT_ORDONNANCIER,
  STATUT_ORDONNANCIER_LABELS,
  STATUT_PIECE_ORDONNANCIER,
  TRIS_JOURNAL_ORDONNANCIER,
  TYPE_PIECE_ORDONNANCIER,
  TYPE_PIECE_ORDONNANCIER_VALUES,
  TYPES_PIECE_ORDONNANCIER_LIBELLES,
} from "@pharmakon/shared/constants/ordonnancier.js";
import { FUSEAU_OFFICINE_DEFAUT, SEUIL_FIN_PROCHE_JOURS } from "@pharmakon/shared/traitement";

export {
  CHAMPS_DISPENSATION_CORRIGEABLES,
  EXTENSIONS_PIECE_ORDONNANCIER,
  LIBELLES_CHAMPS_DISPENSATION,
  MIMES_PIECE_ORDONNANCIER,
  ORDONNANCIER_DISPENSATION_BORNES,
  PIECES_ORDONNANCIER_BORNES,
  SEUIL_FIN_PROCHE_JOURS,
  STATUT_ORDONNANCIER,
  STATUT_ORDONNANCIER_LABELS,
  STATUT_PIECE_ORDONNANCIER,
  TRIS_JOURNAL_ORDONNANCIER,
  TYPE_PIECE_ORDONNANCIER,
  TYPE_PIECE_ORDONNANCIER_VALUES,
  TYPES_PIECE_ORDONNANCIER_LIBELLES,
};

/** The officine zone of the dispensation dates (the server's `FUSEAU_ORDONNANCIER` = Africa/Algiers). */
export const FUSEAU_ORDONNANCIER = FUSEAU_OFFICINE_DEFAUT;

/** The `accept` of the attachment input: the accepted MIME types and their extensions (.jpeg too). */
export const ACCEPT_PIECES_ORDONNANCIER = Object.freeze([
  ...MIMES_PIECE_ORDONNANCIER,
  ...Object.values(EXTENSIONS_PIECE_ORDONNANCIER),
  ".jpeg",
]).join(",");

/** Platform-governed screen values. */
export const ORDONNANCIER_UI = Object.freeze({
  /** Journal page size (the legacy register's 20, within the server's 200 cap). */
  limit: 20,
  /** Default sort: the newest prescriptions first (the server's default `date_ordonnance desc`). */
  tri_defaut: Object.freeze({ by: "date_ordonnance", order: "desc" }),
  /** An upload of up to 5 × 5 Mo, or a read of one, gets more than the client's 15 s default. */
  televersement_timeout_ms: 120_000,
  /** The drawer width token (`--pk-drawer-lg`, 720 px): the entry, the form and the attachment list. */
  largeur_tiroir: "lg",
  /** Below this content width the filter bar wraps on two rows (the grid hides its priority 2 / 3). */
  largeur_compacte: 1000,
});

/** The URL keys of the journal (filters live in the URL: shareable, Back-safe). */
export const PARAMS_JOURNAL_ORDONNANCIER = Object.freeze({
  NO_ORDONNANCE: "q",
  STATUT: "statut",
  MEDECIN: "medecin_id",
  CAISSIER: "caissier_id",
  BORDEREAU: "bordereau",
  A_COMPLETER: "a_completer",
  DU: "du",
  AU: "au",
});
